const JSZip = require('jszip')
const zip = new JSZip()

module.exports = function getFilesFromZip(file) {
  return zip.loadAsync(file, { type: 'arrayBuffer' })
    .then(data => {
      const files = Object.values(data.files).filter(f => !f.dir)
      const promises = files.map(
        file => new Promise((resolve, reject) => {
          zip.file(file.name)
            .async("arraybuffer")
            .then((buffer) => {
              if (file.name.indexOf('.wav') !== -1) {
                const ctx = new AudioContext()
                function successCallback(audioBuffer) {
                  resolve({
                    name: file.name,
                    buffer: audioBuffer
                  })
                }
                function errorCallback(error) {
                  reject(error)
                }
                ctx.decodeAudioData(buffer, successCallback, errorCallback)
              } else {
                resolve({
                  name: file.name,
                  buffer: buffer
                })
              }
            })
            .catch(reject)
          })
      )
      return Promise.all(promises)
    })
}
